import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const TwitterOutlined32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      className={cn(
        chroma === 'default' && s.twitterFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M15.84 1.44c7.947 0 14.4 6.453 14.4 14.4s-6.453 14.4-14.4 14.4-14.4-6.453-14.4-14.4 6.453-14.4 14.4-14.4zm0 1.5c-7.119 0-12.9 5.781-12.9 12.9 0 7.119 5.781 12.9 12.9 12.9 7.119 0 12.9-5.781 12.9-12.9 0-7.119-5.781-12.9-12.9-12.9zM18.533 10c.812 0 1.55.365 2.067.913.665-.11 1.256-.365 1.81-.694-.222.658-.665 1.205-1.145 1.643.554-.036 1.107-.219 1.624-.438a5.455 5.455 0 01-1.402 1.497v.365c0 3.798-2.88 8.18-8.085 8.18a8.013 8.013 0 01-4.357-1.279c.222.037.443.037.665.037 1.329 0 2.547-.475 3.507-1.242a2.891 2.891 0 01-2.658-2.008c.147.036.332.036.517.036.258 0 .517-.036.738-.109-1.329-.256-2.29-1.424-2.29-2.812v-.036c.407.219.813.365 1.293.365-.738-.548-1.255-1.424-1.255-2.41 0-.548.11-1.022.37-1.46 1.402 1.716 3.47 2.884 5.832 2.994a3.976 3.976 0 01-.074-.657c0-1.607 1.293-2.885 2.843-2.885z"
      fillRule="evenodd"
    />
  </svg>
);

export default TwitterOutlined32;
